module.exports = __webpack_public_path__ + "static/media/iPhone-black-circle.86d23bd0.svg";